import React from 'react';
import { Grid, TextField } from '@material-ui/core';
import { SelectInput } from './style';

const AddCommunicated = ({ formData, setFormData, match, templates, loadTemplate }) => {
  return (
    <Grid container spacing={2}>
      <Grid item xs={6}>
        <TextField
          label="Título"
          disabled={match}
          fullWidth
          value={formData?.title || ''}
          onChange={(e) => setFormData({ ...formData, title: e.target.value })}
          margin="normal"
          variant="outlined"
        />
      </Grid>
      <Grid item xs={4}>
        <TextField
          label="Público (Digite um e-mail)"
          disabled={match}
          fullWidth
          value={formData?.publico || ''}
          onChange={(e) => setFormData({ ...formData, publico: e.target.value })}
          margin="normal"
          variant="outlined"
        />
      </Grid>
      <Grid item xs={2}>
        <SelectInput
          native
          disabled={match}
          variant="outlined"
          value={formData?.channel || ''}
          onChange={(e) => {
            loadTemplate(e.target.value);
            setFormData({ ...formData, channel: parseInt(e.target.value) });
          }}
          inputProps={{
            name: 'Grupo',
          }}
        >
          <option aria-label="None" value="">
            Canal?
          </option>
          {templates.map((i) => {
            return (
              <option key={i.id} value={i.id}>
                {i.title}
              </option>
            );
          })}
        </SelectInput>
      </Grid>
    </Grid>
  );
};

export default AddCommunicated;
